// « Lời mời đang chờ » cho email đã xác minh của chính người dùng (SAA-2026-011 D1 / D6): không cần link trong email —
// đăng nhập ở đâu cũng thấy, nhận theo id.
import { qk } from "@secretaa/sdk-react";
import { Button } from "@secretaa/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { api } from "../../app/api.ts";
import { useSession } from "../../app/session.ts";
import { errorMessage } from "../../shared/errors.ts";
import { FormError } from "../../shared/form.tsx";

export function usePendingInvitations() {
  const session = useSession();
  return useQuery({ queryKey: qk.myInvitations(), queryFn: api.invitations.pending, enabled: !!session.data, retry: false });
}

export function PendingInvitations() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const pending = usePendingInvitations();
  const accept = useMutation({
    mutationFn: (id: string) => api.invitations.acceptById(id),
    onSuccess: async (r) => {
      await Promise.all([qc.invalidateQueries({ queryKey: qk.me() }), qc.invalidateQueries({ queryKey: qk.myInvitations() })]);
      navigate(`/w/${r.workspaceId}/overview`);
    },
  });
  if (!pending.data?.length) return null;
  return (
    <section aria-labelledby="pending-invitations" className="flex flex-col gap-2">
      <h2 id="pending-invitations" className="text-base font-semibold">
        {t("invite.pendingTitle")}
      </h2>
      <FormError message={accept.isError ? errorMessage(t, accept.error) : null} />
      <ul className="flex flex-col gap-2">
        {pending.data.map((inv) => (
          <li key={inv.id} className="flex flex-col gap-2 rounded-md border border-(--saa-border) bg-(--saa-surface) px-4 py-3">
            <p className="text-sm">{t("invite.pendingItem", { inviter: inv.inviterName, workspace: inv.workspaceName, role: t(`members.roles.${inv.role}`) })}</p>
            <Button className="self-start" disabled={accept.isPending} onClick={() => accept.mutate(inv.id)}>
              {accept.isPending && accept.variables === inv.id ? t("invite.accepting") : t("invite.accept")}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
